import { render } from "./DragHandle.vue?vue&type=template&id=1ad3e962"
import script from "./DragHandle.vue?vue&type=script&lang=js"
export * from "./DragHandle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__